import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  showTagline?: boolean;
  className?: string;
  to?: string;
}

const sizeClasses = {
  sm: "text-[24px]",
  md: "text-[36px]",
  lg: "text-[48px]",
};

export function Logo({ size = "md", showTagline, className, to }: LogoProps) {
  const inner = (
    <div className={cn("text-center", className)}>
      <div
        className={cn(
          "font-semibold italic tracking-tight text-[#1a1a1a] leading-none",
          sizeClasses[size],
        )}
        style={{ fontFamily: "'Crimson Pro', Georgia, serif" }}
      >
        Finally
      </div>
      {showTagline ? (
        <p className="mt-2 text-[13px] text-[#6c757d] tracking-wide">People work with people</p>
      ) : null}
    </div>
  );
  if (to) {
    return (
      <Link to={to} className="inline-block no-underline">
        {inner}
      </Link>
    );
  }
  return inner;
}
